// 새 버전 배포 감지
// 설치형 앱은 백그라운드에서 다시 열어도 새로고침되지 않아 예전 코드가 계속 실행된다.
// 서버의 index.html 이 가리키는 빌드 파일(main.[해시].js)이 지금 실행 중인 것과 다르면 새 버전으로 판단한다.

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const BUNDLE_RE = /\/static\/js\/main\.[0-9a-f]+\.js/;

const currentBundle = () => {
    const script = [...document.scripts].find(s => BUNDLE_RE.test(s.src));
    return script ? script.src.match(BUNDLE_RE)[0] : null;
};

const fetchLatestBundle = async () => {
    const res = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const match = (await res.text()).match(BUNDLE_RE);
    return match ? match[0] : null;
};

// 사진·파일 선택 화면에서 돌아온 직후에는 새로고침하면 고른 파일이 사라진다
const PICKER_GRACE_MS = 2 * 60 * 1000;
let filePickerOpenedAt = 0;
export const noteFilePickerOpened = () => { filePickerOpenedAt = Date.now(); };

// 입력 중인 내용·진행 중인 작업이 없을 때만 자동 새로고침
export const isSafeToReload = () => {
    if (Date.now() - filePickerOpenedAt < PICKER_GRACE_MS) return false;
    const message = document.getElementById('message');
    if (message && message.value.trim()) return false;
    return !document.querySelector(
        '.edit-area, .upload-progress-container, .dl-backdrop, .adm-dialog, .modal-overlay, .confirm-overlay, .lightbox-overlay, .pin-edit-area, textarea:focus, input:focus'
    );
};

export const reloadToLatest = async () => {
    try {
        const reg = await navigator.serviceWorker?.getRegistration();
        await reg?.update();
    } catch {}
    window.location.reload();
};

/**
 * @param {() => void} onUpdateAvailable 자동 새로고침을 할 수 없을 때 호출 (배너 표시 등)
 * @returns {() => void} 정리 함수
 */
export function startUpdateWatcher(onUpdateAvailable) {
    const running = currentBundle();
    if (!running) return () => {}; // 개발 서버 등
    let notified = false;
    let checking = false;

    const check = async ({ resumed = false } = {}) => {
        if (checking || notified) return;
        checking = true;
        try {
            const latest = await fetchLatestBundle();
            if (!latest || latest === running) return;
            // 앱으로 돌아온 순간이고 잃을 내용이 없으면 바로 최신 버전으로
            if (resumed && isSafeToReload()) return reloadToLatest();
            notified = true;
            onUpdateAvailable();
        } catch {
            // 네트워크 오류는 다음 확인 때 다시 시도
        } finally {
            checking = false;
        }
    };

    const onVisible = () => { if (document.visibilityState === 'visible') check({ resumed: true }); };
    const onOnline = () => check({ resumed: true });
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('online', onOnline);
    window.addEventListener('pageshow', onOnline);
    const timer = setInterval(() => check(), CHECK_INTERVAL_MS);

    return () => {
        document.removeEventListener('visibilitychange', onVisible);
        window.removeEventListener('online', onOnline);
        window.removeEventListener('pageshow', onOnline);
        clearInterval(timer);
    };
}

// 서비스 워커 등록 + 앱으로 돌아올 때마다 서비스 워커 업데이트 확인
export function registerServiceWorker() {
    if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') return;
    const register = async () => {
        try {
            const reg = await navigator.serviceWorker.register('/sw.js');
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') reg.update().catch(() => {});
            });
        } catch {}
    };
    // 스크립트가 늦게 실행되어 load 가 이미 끝났을 수 있다
    if (document.readyState === 'complete') register();
    else window.addEventListener('load', register, { once: true });
}
